import ForwardVM from './ForwardVM';

/**
 * Thin wrapper for off-hours context
 * Maintains API compatibility - other components import OffHoursForwardVM
 */
const OffHoursForwardVM = (props) => {
  return <ForwardVM {...props} context="offHours" />;
};

export default OffHoursForwardVM;
